import PublicLayout from '../layouts/PublicLayout'
import StandingsTable from '../components/StandingsTable'
import Monogram from '../components/Monogram'
import usePoll from '../hooks/usePoll'
import { isPlayed, penaltiesLabel, homeWins as hw, awayWins as aw } from '../lib/result'

const STAGE_LABELS = {
  semifinal: 'Meia-final',
  final: 'Final',
  third_place: '3º / 4º lugar',
  fifth_place: '5º / 6º lugar',
  seventh_place: '7º / 8º lugar',
  ninth_place: '9º / 10º lugar',
}

function FormPills({ form = [] }) {
  if (!form.length) return <span className="form-empty">Sem jogos ainda</span>
  return (
    <div className="form">
      {form.map((o, i) => (
        <span key={i} className={`fp ${o}`}>
          {o}
        </span>
      ))}
    </div>
  )
}

export default function Match({ currentEdition, editions, match, groupName, groupRows, form }) {
  usePoll(15000)

  const live = match.status === 'live'
  const played = isPlayed(match)
  const hasTeams = match.home && match.away
  const homeWin = hw(match)
  const awayWin = aw(match)

  const stageLabel =
    match.stage === 'group' ? `Fase de grupos · Grupo ${match.group}` : STAGE_LABELS[match.stage] || 'Jogo'
  const meta = [`Jogo ${match.gameNumber}`, match.time, match.field ? `Campo ${match.field}` : null]
    .filter(Boolean)
    .join(' · ')
  const title = hasTeams
    ? `${match.home.shortName} vs ${match.away.shortName}`
    : match.label || `Jogo ${match.gameNumber}`

  return (
    <PublicLayout currentEdition={currentEdition} editions={editions} active="calendario" title={title}>
      <div className="match-page">
        <div className="mp-head">
          <span className="mp-stage">{stageLabel}</span>
          <span className="mp-meta">{meta}</span>
          {live && (
            <span className="mp-live">
              <span className="d" />
              ao vivo
            </span>
          )}
        </div>

        <div className="mp-score">
          {hasTeams ? (
            <>
              <div className={`mp-team ${homeWin ? 'win' : ''}`}>
                <Monogram team={match.home} size={64} />
                <span>{match.home.shortName}</span>
              </div>
              <div className="mp-res">
                {played ? (
                  <>
                    <b className={homeWin ? 'w' : ''}>{match.homeScore}</b>
                    <i>–</i>
                    <b className={awayWin ? 'w' : ''}>{match.awayScore}</b>
                    {penaltiesLabel(match) && <span className="mp-pens">{penaltiesLabel(match)}</span>}
                  </>
                ) : (
                  <i className="vs">vs</i>
                )}
              </div>
              <div className={`mp-team ${awayWin ? 'win' : ''}`}>
                <Monogram team={match.away} size={64} />
                <span>{match.away.shortName}</span>
              </div>
            </>
          ) : (
            <div className="mp-tbd">{match.label || 'A definir'}</div>
          )}
        </div>

        {groupRows && (
          <>
            {hasTeams && (
              <div className="mp-forms">
                <div>
                  <span className="lbl">{match.home.shortName}</span>
                  <FormPills form={form?.home} />
                </div>
                <div>
                  <span className="lbl">{match.away.shortName}</span>
                  <FormPills form={form?.away} />
                </div>
              </div>
            )}
            <StandingsTable
              name={groupName}
              rows={groupRows}
              highlight={groupRows.filter((r) => r.isMatchTeam).map((r) => r.team.slug)}
            />
          </>
        )}
      </div>
    </PublicLayout>
  )
}
